import { FC } from "react";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import {
  ZooplaPriceModes,
  ZooplaPricePerAreaModes,
  ZooplaPricePerUnitModes,
} from "../../../typings";

const keyTranslations: Record<ZooplaPriceModes, string> = {
  [ZooplaPricePerUnitModes.VAL_ESTIMATE]: "comparables.map.legend.zoopla_valuation_key",
  [ZooplaPricePerUnitModes.VAL_LAST]: "comparables.map.legend.zoopla_last_value_key",
  [ZooplaPricePerUnitModes.RENT_ASKING]: "comparables.map.legend.zoopla_rent_asking_key",
  [ZooplaPricePerUnitModes.RENT_ESTIMATE]: "comparables.map.legend.zoopla_rent_estimate_key",
  [ZooplaPricePerAreaModes.VAL_ESTIMATE]: "comparables.map.legend.zoopla_valuation_key",
  [ZooplaPricePerAreaModes.VAL_LAST]: "comparables.map.legend.zoopla_last_value_key",
  [ZooplaPricePerAreaModes.RENT_ASKING]: "comparables.map.legend.zoopla_rent_asking_key",
  [ZooplaPricePerAreaModes.RENT_ESTIMATE]: "comparables.map.legend.zoopla_rent_estimate_key",
};
const descriptionTranslations: Record<ZooplaPriceModes, string> = {
  [ZooplaPricePerUnitModes.VAL_ESTIMATE]: "comparables.map.legend.zoopla_valuation_description",
  [ZooplaPricePerUnitModes.VAL_LAST]: "comparables.map.legend.zoopla_last_value_description",
  [ZooplaPricePerUnitModes.RENT_ASKING]: "comparables.map.legend.zoopla_rent_asking_description",
  [ZooplaPricePerUnitModes.RENT_ESTIMATE]:
    "comparables.map.legend.zoopla_rent_estimate_description",
  [ZooplaPricePerAreaModes.VAL_ESTIMATE]: "comparables.map.legend.zoopla_valuation_description",
  [ZooplaPricePerAreaModes.VAL_LAST]: "comparables.map.legend.zoopla_last_value_description",
  [ZooplaPricePerAreaModes.RENT_ASKING]: "comparables.map.legend.zoopla_rent_asking_description",
  [ZooplaPricePerAreaModes.RENT_ESTIMATE]:
    "comparables.map.legend.zoopla_rent_estimate_description",
};

export interface PricePaidProps {
  priceMode: ZooplaPriceModes;
}
export const ZooplaLegend: FC<PricePaidProps> = ({ priceMode }) => {
  const { t } = useTranslation();

  return (
    <div className="atlas-p-3 atlas-flex-col atlas-items-stretch" data-testid="zoopla-legend">
      <div className="atlas-flex atlas-m-2" data-testid="price-per-area-item">
        <span className="atlas-flex atlas-items-flex-start">
          <span className="atlas-w-6 atlas-h-6 atlas-shrink-0 atlas-bg-[#7421bc] atlas-rounded-full atlas-border-solid atlas-border-white atlas-border atlas-mr-2" />
          <span className="atlas-font-bold atlas-mt-1">{t(keyTranslations[priceMode])}</span>
          <span className="atlas-px-1 atlas-mt-1 atlas-shrink-0">-</span>
          <span className="atlas-flex-1 atlas-mt-1">{t(descriptionTranslations[priceMode])}</span>
        </span>
      </div>
    </div>
  );
};
